export default "__VITE_ASSET__BZXXjIwg__"